'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var S = {};
S.Ratio = styled__default["default"].div.withConfig({
  displayName: "styles__Ratio",
  componentId: "sc-1krrdnw-0"
})(["box-sizing:border-box;width:100%;padding-bottom:", "%;position:relative;"], function (_ref) {
  var ratio = _ref.ratio;
  return ratio;
});
S.Child = styled__default["default"].div.withConfig({
  displayName: "styles__Child",
  componentId: "sc-1krrdnw-1"
})(["box-sizing:border-box;width:100%;height:100%;position:absolute;top:0;left:0;"]);

var Ratio = function Ratio(_ref) {
  var children = _ref.children,
    width = _ref.width,
    height = _ref.height,
    className = _ref.className;
  var ratio = height / width * 100;
  return /*#__PURE__*/React__default["default"].createElement(S.Ratio, {
    ratio: ratio,
    className: className
  }, /*#__PURE__*/React__default["default"].createElement(S.Child, null, children));
};
Ratio.propTypes = {
  /** Ratio content */
  children: PropTypes__default["default"].node.isRequired,
  /** Width value */
  width: PropTypes__default["default"].number,
  /** Height value */
  height: PropTypes__default["default"].number,
  className: PropTypes__default["default"].string
};
Ratio.defaultProps = {
  width: 16,
  height: 9,
  className: ''
};

module.exports = Ratio;
